import {
  ADD_LESSON,
  ADD_LESSON_SUCCESS,
  ADD_LESSON_CLEAN,
  ADD_LESSON_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: {},
}

const LessonAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_LESSON:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_LESSON_SUCCESS:
      state = {
        ...state,
        lesson: action.payload.lesson,
        loading: false,
        done: true,
      }
      break
    case ADD_LESSON_CLEAN:
      state = initialState
      break
    case ADD_LESSON_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LessonAdd
